/*
 * @Author: MancyWang mengxiaowang@sjtu.edu.cn
 * @Date: 2023-01-13 15:17:56
 * @LastEditors: MancyWang mengxiaowang@sjtu.edu.cn
 * @LastEditTime: 2023-04-25 11:00:36
 * @FilePath: \xingou-commecial-plat-frontend\src\main.js
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import Vue from 'vue'
import * as echarts from 'echarts'
import ElementUI from 'element-ui'
import { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/utils/aegis.js'
import App from '@/App'
import router from '@/router'                 // api: https://github.com/vuejs/vue-router
import store from '@/store'                   // api: https://github.com/vuejs/vuex
import VueCookie from 'vue-cookie'            // api: https://github.com/alfhen/vue-cookie
import '@/icons'                              // api: http://www.iconfont.cn/
import '@/assets/scss/index.scss'
import httpRequest from '@/utils/httpRequest' // api: https://github.com/axios/axios
import { isAuth } from '@/utils'
import cloneDeep from 'lodash/cloneDeep'
// import regionSelect from '@/views/modules/utils/region-select.vue'
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import specific icons */
import { faHeartPulse,faCircleH,faFileWaveform,faSquareH,faVial,faHardDrive,faDroplet,faStethoscope,faWeightScale,faTemperatureThreeQuarters,faCubes,faFlask,faPersonBreastfeeding,faUserNurse,faUserGroup,faUserDoctor,faHouseMedical,faPeopleRoof,faFileSignature,faBuildingShield,faGears,faBaby,faHeartCirclePlus} from '@fortawesome/free-solid-svg-icons'
import { faCircle } from '@fortawesome/free-regular-svg-icons'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* add icons to the library */
library.add(faHeartPulse,faCircleH,faFileWaveform,faSquareH,faVial,faCircle,faHardDrive,faDroplet,faStethoscope,faWeightScale,faTemperatureThreeQuarters,faCubes,faFlask,faPersonBreastfeeding,faUserNurse, faUserGroup,faUserDoctor,faHouseMedical,faPeopleRoof,faFileSignature,faBuildingShield,faGears,faBaby,faHeartCirclePlus )
const Snap = require(`imports-loader?this=>window,fix=>module.exports=0!snapsvg/dist/snap.svg.js`);
Vue.prototype.$Snap = Snap

//将DOM转为PDF
import htmlToPdf from '@/utils/htmlToPdf'
import htmlToPdf_horizon from '@/utils/htmlToPdf_horizon'
Vue.use(htmlToPdf);
Vue.use(htmlToPdf_horizon);

//签名组件
import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad);

//修改element-ui主题
import '../theme/index.css'

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false

Vue.use(VueCookie)
Vue.config.productionTip = false
Vue.use(ElementUI)

// 大屏组件
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)
// 自定义的全局组件
// Vue.component('region-select', regionSelect)


// 挂载全局
Vue.prototype.$http = httpRequest // ajax请求方法
Vue.prototype.$echarts = echarts
Vue.prototype.isAuth = isAuth     // 权限方法
Vue.prototype.$message = Message

// 保存整站vuex本地储存初始状态
// window.SITE_CONFIG['storeState'] = cloneDeep(store.state)
Vue.config.devtools = process.env.NODE_ENV === 'development';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})